import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useSnackbar } from 'notistack';
import { CompaniesService } from 'api';
import { COMPANY_ZANBATO_CLOSED_TRANSACTIONS_QUERY_KEY } from 'common/constants/services/companies';

const useGetCompanyZanbatoClosedTransactions = (companyId: number | undefined) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data, isLoading, isError } = useQuery({
    enabled: !isNil(companyId),
    queryFn: () => CompaniesService.apiCompaniesZanbatoClosedTransactionsRead(companyId as number),
    queryKey: [COMPANY_ZANBATO_CLOSED_TRANSACTIONS_QUERY_KEY, companyId],
    retry: false,
  });

  useEffect(() => {
    if (isError) {
      enqueueSnackbar('An error occurred loading Zanbato closed transactions.', { variant: 'error' });
    }
  }, [isError, enqueueSnackbar]);

  return { data, isLoading, isError };
};

export default useGetCompanyZanbatoClosedTransactions;
